import React from 'react';
import type { BaseCropComponentProps } from '../types';
import { useCropStore } from '../store/cropStore';
import { formatDimensions } from '../utils';
import { infoBarContainer, infoDimensions } from '../styles/index';

interface CropInfoBarProps extends BaseCropComponentProps {
  showSelection?: boolean;
  originalLabel?: string;
  selectionLabel?: string;
}

export const CropInfoBar: React.FC<CropInfoBarProps> = ({
  showSelection = true,
  originalLabel = 'Original',
  selectionLabel = 'Selection',
  className,
}) => {
  const { originalWidth, originalHeight, croppedAreaPixels, hasSelection } = useCropStore();

  const getSelectionDimensions = (): string | null => {
    if (!croppedAreaPixels || !hasSelection()) {
      return null;
    }

    return formatDimensions(croppedAreaPixels.width, croppedAreaPixels.height);
  };

  const selectionDims = getSelectionDimensions();

  return (
    <div className={`${infoBarContainer} ${className || ''}`}>
      <div>
        <span>{originalLabel}: </span>
        <span className={infoDimensions}>{formatDimensions(originalWidth, originalHeight)}</span>
      </div>

      {showSelection && selectionDims && (
        <div>
          <span>{selectionLabel}: </span>
          <span className={infoDimensions}>{selectionDims}</span>
        </div>
      )}
    </div>
  );
};
